import { isInvestorProLimitExceeded } from 'helpers/deposit';
import { useSelector } from 'react-redux';

import { getDisabledProjectTime } from '../../../helpers/DisabledProject/DisabledProject';

const selector = (state) => ({
  projectCategory: state?.Project.projects,
  userLevel: state.Profile.user.level,
  investorLevel: state.Profile.user.investorLevel,
  baseDepositLevel: state.Profile.user.base_deposit_level,
  isDepositButtonDisabledByInvestment: state.Project.isDepositButtonDisabledByInvestment,
});

/**
 * @typedef InvestorProLimit
 * @property {number} allPackages
 * @property {number} perUser
 */

/**
 * @argument {InvestorProLimit} investorProLimit - InvestorProLimit
 */
export const useIsProjectDisabled = (investorProLimit) => {
  const { projectCategory, investorLevel, baseDepositLevel } = useSelector(selector);

  const checkInvestorPro = (project) => {
    const today = new Date();
    const startDate = new Date(project.startDate);
    const dueDate = new Date(project.dueDate);
    if (startDate > today || dueDate < today) {
      return true;
    }

    return (
      isInvestorProLimitExceeded(investorProLimit) || !(investorLevel >= +project.investor_level)
    );
  };

  const isProjectDisabled = (project) => {
    if (getDisabledProjectTime(project.service_name)) {
      return true;
    }

    if (projectCategory.slug === 'investor_pro' && investorLevel < 5) {
      return true;
    }

    if (projectCategory.slug === 'investor' || projectCategory.slug === 'investor-pro') {
      const today = new Date();
      const startDate = new Date(project.startDate);
      const dueDate = new Date(project.dueDate);

      if (startDate > today || dueDate < today) {
        return true;
      }

      return !(baseDepositLevel >= +project.investor_level);
    }

    if (projectCategory.slug === 'bazovyj-paket') {
      const projectBaseLevel = parseInt(project.service_name.replace('basic', ''));
      if (baseDepositLevel >= projectBaseLevel) return true;
    }

    return false;
  };

  return isProjectDisabled;
};
